/**
 *
 * @param
 * param1: Name Component
 *
 */
const componentIsMounted = (nameComponent) => {
  return {
    type: `${nameComponent}_MOUNTED`,
    [`${nameComponent.toLowerCase()}_mounted`]: true,
  };
};

const componentIsUnmounted = (nameComponent) => {
  return {
    type: `${nameComponent}_UNMOUNTED`,
    [`${nameComponent.toLowerCase()}_mounted`]: false,
  };
};

export default {
  componentIsMounted,
  componentIsUnmounted,
};
